import { AxiosResponse } from "axios";

import { $axios } from "@/shared/api";

import { IUpdateDialogTitleParams, IUpdateDialogTitleResponse } from "../types";

class EditDialogService {
  async updateDialogTitle({ dialog_id, title }: IUpdateDialogTitleParams) {
    const response = await $axios.put<
      IUpdateDialogTitleParams,
      AxiosResponse<IUpdateDialogTitleResponse>
    >(`/UpdateDialogTitle/${dialog_id}`, { title });

    return response.data;
  }
}

export const editDialogService = new EditDialogService();
